/**
 * @desc 更新下载时间
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export type Response = defs.report.Response;
export function request(requestId: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/reportTaskRecord/updateDownloadTime/${requestId}`, {
      method: "POST",

      ...options,
    }),
  );
}
